import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const RaterHelpStyles = makeStyles()((theme: Theme) => ({
  root: {
    width: '100%',
    height: '100%',
    minHeight: 'calc(100vh - 3.125rem)',
  },
  heading: {
    marginTop: '5rem',
    color: 'white',
    textAlign: 'center',
    flexGrow: 1,
  },
  closeButton: {
    marginRight: '-3rem',
    height: 'fit-content',
    alignSelf: 'flex-end',
    color: 'white',
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      top: '3rem',
      right: '3rem',
    },
  },
  okButton: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginTop: '32px',
    marginBottom: '87px',
  },
  subHeading: {
    textAlign: 'center',
    fontSize: '18px',
    fontWeight: 700,
    color: 'white',
    marginBottom: '0.5rem',
  },
  desc: {
    textAlign: 'center',
    fontSize: '18px',
    fontWeight: 400,
    color: 'white',
  },
  marginTop24px: {
    marginTop: '24px',
  },
}));

export default RaterHelpStyles;
